import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const BoxContainer = styled.div`
  background-color: ${(props) =>
    props.$background ? props.theme[props.$background] : props.theme.greyLight};
  border-radius: 25px;
`

const Box = ({ background, className, children }) => {
  return (
    <BoxContainer $background={background} className={className}>
      {children}
    </BoxContainer>
  )
}

Box.propTypes = {
  background: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export default Box
